import { addSymbol } from 'virtual:svg-sprite-runtime'
const id = "icon_chevron-down"
const viewBox = "0 0 24 24"
addSymbol(id, "<path d=\"M11.223 17.678L2.322 8.777a1.1 1.1 0 010-1.554L3.36 6.184a1.1 1.1 0 011.553-.002L12 13.237l7.087-7.054a1.099 1.099 0 011.553.002l1.038 1.038a1.1 1.1 0 010 1.554l-8.901 8.901a1.1 1.1 0 01-1.554 0z\" fill=\"currentColor\"/>", viewBox)
export default { id, viewBox }